var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCeramicBowl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 18.878,
    viewBox: "0 0 32 18.878",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(-1304 -516)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    id: "Path_64",
    "data-name": "Path 64",
    d: "M-1982.18,18.877a.721.721,0,0,1-.72-.72V16.305a8.591,8.591,0,0,1-5.031-2.868A8.589,8.589,0,0,1-1990,7.858V.72c0-.29.245-.516.65-.567a11.916,11.916,0,0,1,1.437-.007c.56.013,1.25.027,2.078.007,4.323-.1,12.937-.153,27.111-.153h.008a.719.719,0,0,1,.715.726V7.858a8.6,8.6,0,0,1-2.067,5.579,8.593,8.593,0,0,1-5.031,2.868v1.852a.721.721,0,0,1-.72.72Zm.724-1.444h14.907V16.428h-14.907Zm-7.1-9.575a7.15,7.15,0,0,0,7.128,7.126h14.854a7.152,7.152,0,0,0,7.127-7.127V1.449h-29.111Z",
    transform: "translate(3294 516)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeramicBowl);
export default __webpack_public_path__ + "static/media/ceramicBowl.22e9312608f675591c13509141b94e1b.svg";
export { ForwardRef as ReactComponent };